import { Search } from '@mui/icons-material';
import { alpha, Button, Paper, Stack, Typography } from '@mui/material';
import CustomSelect from 'Components/CustomSelect/CustomSelect';
import SearchTextField from 'Components/SeachTextField/SearchTextField';
import { colors } from 'Constants/Colors';
import useCoursesLessonsFilters from 'Pages/courses/Hooks/useCoursesLessonsFilters';
import { SearchButton } from 'Pages/reports/[submodules]/employees/components/EmployeesReportFilters/EmployeesReportFilters.styled';
import { Controller } from 'react-hook-form';
import { CourseEmployeeFiltersFormT } from 'types';

interface Props {
  onSearch?: (filters: CourseEmployeeFiltersFormT) => void;
}

const CoursesLessonsFilters = ({ onSearch }: Props) => {
  const { control, terminals, departments, jobTitles, isDirty, getValues, onResetFilters } = useCoursesLessonsFilters({
    onSearch,
  });

  return (
    <Paper sx={{ display: 'flex', flexDirection: 'column', gap: '10px', padding: '20px', borderRadius: '15px' }}>
      <Typography variant="subtitle2" sx={{ color: alpha(colors.BLACK, 0.5) }}>
        Filtros
      </Typography>
      <Stack direction="row" spacing={3}>
        <Controller
          control={control}
          name="fullName"
          render={({ field }) => <SearchTextField placeholder="Buscar empleado" {...field} />}
        />
        <Controller
          control={control}
          name="terminalId"
          render={({ field }) => (
            <CustomSelect
              placeholder="Buscar terminal"
              options={terminals.map(terminal => ({
                value: terminal.id,
                label: terminal.name,
              }))}
              {...field}
            />
          )}
        />
        <Controller
          control={control}
          name="departmentId"
          render={({ field }) => (
            <CustomSelect
              placeholder="Buscar departamento"
              options={departments.map(department => ({
                value: department.id,
                label: department.name,
              }))}
              {...field}
            />
          )}
        />
        <Controller
          control={control}
          name="jobTitleId"
          render={({ field }) => (
            <CustomSelect
              placeholder="Buscar puestos"
              options={jobTitles.map(jobTitle => ({
                value: jobTitle.id,
                label: jobTitle.name,
              }))}
              {...field}
            />
          )}
        />

        <SearchButton
          variant="outlined"
          color="success"
          hidden={!isDirty}
          startIcon={<Search />}
          onClick={() => {
            const values = Object.fromEntries(
              Object.entries(getValues()).filter(([_, value]) => value !== undefined && value !== '')
            ) as CourseEmployeeFiltersFormT;
            onSearch(values);
          }}
        >
          Buscar
        </SearchButton>

        {isDirty && (
          <Button variant="outlined" color="error" onClick={onResetFilters}>
            Limpiar
          </Button>
        )}
      </Stack>
    </Paper>
  );
};

export default CoursesLessonsFilters;
